import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock, withCtx as _withCtx, createTextVNode as _createTextVNode, toDisplayString as _toDisplayString, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-060f2136"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  id: "log-list-header",
  class: "row g-4 py-4"
}
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  id: "log-list-header-title",
  class: "col-lg-3 d-flex align-items-center"
}, [
  /*#__PURE__*/_createElementVNode("h6", { style: {"color":"var(--cor_texto_1)"} }, "Push Notification")
], -1))
const _hoisted_3 = {
  id: "log-list-header-search",
  class: "col-sm-9 col-lg-7"
}
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", {
  class: "fa fa-search",
  style: {"color":"var(--cor_btn_1)"}
}, null, -1))
const _hoisted_5 = { class: "col-sm-3 col-lg-2" }
const _hoisted_6 = { class: "card rounded mb-4 p-4" }
const _hoisted_7 = { class: "row g-4" }
const _hoisted_8 = { class: "col-md-6 col-lg-3" }
const _hoisted_9 = { class: "col-md-6 col-lg-3" }
const _hoisted_10 = { class: "col-md-6 col-lg-3" }
const _hoisted_11 = { class: "col-md-6 col-lg-3" }
const _hoisted_12 = { class: "col-md-6 col-lg-3" }
const _hoisted_13 = { class: "col-md-6 col-lg-2" }
const _hoisted_14 = { class: "col-md-6 col-lg-3" }
const _hoisted_15 = { class: "col-md-6 col-lg-2" }
const _hoisted_16 = { class: "col-md-12 col-lg-2 d-flex align-items-center justify-content-center" }
const _hoisted_17 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", {
  class: "fa fa-filter",
  "aria-hidden": "true",
  style: {"font-size":"1.2rem"}
}, null, -1))
const _hoisted_18 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "ms-2" }, "Filtrar", -1))
const _hoisted_19 = [
  _hoisted_17,
  _hoisted_18
]
const _hoisted_20 = { key: 0 }
const _hoisted_21 = {
  key: 0,
  id: "box-table-log",
  class: "background_1 card"
}
const _hoisted_22 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("svg", {
  width: "100",
  height: "105",
  viewBox: "0 0 100 105",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, [
  /*#__PURE__*/_createElementVNode("mask", {
    id: "mask0_6_3",
    style: {"mask-type":"luminance"},
    maskUnits: "userSpaceOnUse",
    x: "0",
    y: "2",
    width: "100",
    height: "101"
  }, [
    /*#__PURE__*/_createElementVNode("path", {
      d: "M100 2.5H0V102.5H100V2.5Z",
      fill: "white"
    })
  ]),
  /*#__PURE__*/_createElementVNode("g", { mask: "url(#mask0_6_3)" }, [
    /*#__PURE__*/_createElementVNode("path", {
      d: "M50 102.5C56.8985 102.5 62.4945 96.9045 62.4945 90H37.5061C37.5061 96.9045 43.1018 102.5 50 102.5Z",
      fill: "white"
    }),
    /*#__PURE__*/_createElementVNode("path", {
      opacity: "0.4",
      d: "M56.246 12.8203C70.594 15.8008 81.2345 27.9492 81.2345 43.125C81.2345 61.8645 87.445 68.394 91.33 72.4775C91.587 72.748 91.834 73.008 92.0685 73.26C93.2405 74.5175 93.76 76.0255 93.75 77.5C93.7305 80.703 91.215 83.75 87.4805 83.75H12.5196C8.78529 83.75 6.27159 80.703 6.25014 77.5C6.24034 76.0255 6.75989 74.5195 7.93179 73.26C8.16614 73.008 8.41319 72.748 8.67044 72.4775C12.555 68.394 18.7657 61.8645 18.7657 43.125C18.7657 27.9492 29.4064 15.8008 43.754 12.8203V8.75C43.754 5.29885 46.5509 2.5 50 2.5C53.4495 2.5 56.246 5.29885 56.246 8.75V12.8203Z",
      fill: "white"
    })
  ])
], -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_el_input = _resolveComponent("el-input")!
  const _component_CampBtnGenerateExcel = _resolveComponent("CampBtnGenerateExcel")!
  const _component_el_option = _resolveComponent("el-option")!
  const _component_el_select = _resolveComponent("el-select")!
  const _component_el_date_picker = _resolveComponent("el-date-picker")!
  const _component_el_config_provider = _resolveComponent("el-config-provider")!
  const _component_CampTableTh = _resolveComponent("CampTableTh")!
  const _component_CampTableTd = _resolveComponent("CampTableTd")!
  const _component_CampTable = _resolveComponent("CampTable")!
  const _component_CampEmptyListFeedbackV2 = _resolveComponent("CampEmptyListFeedbackV2")!
  const _component_CampFooterPaginationControl = _resolveComponent("CampFooterPaginationControl")!
  const _component_el_skeleton = _resolveComponent("el-skeleton")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createElementVNode("div", _hoisted_1, [
      _hoisted_2,
      _createElementVNode("div", _hoisted_3, [
        _createVNode(_component_el_input, {
          modelValue: _ctx.keywordSearch,
          "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.keywordSearch) = $event)),
          placeholder: "Filtre por palavra chave...",
          type: "text",
          disabled: !(!_ctx.isLoading && Array.isArray(_ctx.logListRender) && _ctx.logListRender.length > 0) && _ctx.keywordSearch.length < 1
        }, null, 8, ["modelValue", "disabled"]),
        _hoisted_4
      ]),
      _createElementVNode("div", _hoisted_5, [
        _createVNode(_component_CampBtnGenerateExcel, {
          "table-data": _ctx.logListRender?.map(el =>({
            title: el.title,
            message: el.message,
            frequency: el.frequency,
            status: el.status,
            competitorName: el.competitorName,
            competitorCPF: el.competitorCPF,
            user_name: el.user_name,
            send_to: el.send_to,
            created_at: el.created_at
          })) || [],
          "renamed-column-list": [
            'title as Título',
            'frequency as Frequência',
            'status as Status',
            'message as Mensagem',
            'competitorName as Vendedor',
            'competitorCPF as CPF',
            'user_name as Enviado por',
            'send_to as Enviado para',
            'created_at as Data'
          ],
          label: "Exportar",
          "file-name": "Relatório de Push Notifications",
          "btn-class": "btn_background_1 btn-sm"
        }, null, 8, ["table-data"])
      ])
    ]),
    _createElementVNode("div", _hoisted_6, [
      _createElementVNode("div", _hoisted_7, [
        _createElementVNode("div", _hoisted_8, [
          _createVNode(_component_el_select, {
            modelValue: _ctx.bodyParamsModel.companyIdList,
            "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.bodyParamsModel.companyIdList) = $event)),
            multiple: "",
            filterable: "",
            "collapse-tags": "",
            clearable: "",
            placeholder: "Selecione uma ou mais companhias",
            class: "w-100",
            disabled: !(Array.isArray(_ctx.companyList))
          }, {
            default: _withCtx(() => [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.companyList, (el) => {
                return (_openBlock(), _createBlock(_component_el_option, {
                  key: el.id,
                  value: el.id,
                  label: `${el.cnpj} - ${el.fantasy_name}`
                }, null, 8, ["value", "label"]))
              }), 128))
            ]),
            _: 1
          }, 8, ["modelValue", "disabled"])
        ]),
        _createElementVNode("div", _hoisted_9, [
          _createVNode(_component_el_select, {
            modelValue: _ctx.bodyParamsModel.storeIdList,
            "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.bodyParamsModel.storeIdList) = $event)),
            multiple: "",
            filterable: "",
            "collapse-tags": "",
            clearable: "",
            placeholder: "Selecione uma ou mais lojas",
            class: "w-100",
            disabled: !(Array.isArray(_ctx.storeList))
          }, {
            default: _withCtx(() => [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.storeList, (el) => {
                return (_openBlock(), _createBlock(_component_el_option, {
                  key: el.id,
                  value: el.id,
                  label: `${el.cnpj} - ${el.fantasy_name}`
                }, null, 8, ["value", "label"]))
              }), 128))
            ]),
            _: 1
          }, 8, ["modelValue", "disabled"])
        ]),
        _createElementVNode("div", _hoisted_10, [
          _createVNode(_component_el_select, {
            modelValue: _ctx.bodyParamsModel.competitorIdList,
            "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.bodyParamsModel.competitorIdList) = $event)),
            multiple: "",
            filterable: "",
            "collapse-tags": "",
            clearable: "",
            placeholder: "Selecione um ou mais vendedores",
            class: "w-100",
            disabled: !(Array.isArray(_ctx.competitorList)) || (Array.isArray(_ctx.competitorList) && _ctx.competitorList.length < 1)
          }, {
            default: _withCtx(() => [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.competitorList, (el) => {
                return (_openBlock(), _createBlock(_component_el_option, {
                  key: el.id,
                  value: el.id,
                  label: el.name
                }, null, 8, ["value", "label"]))
              }), 128))
            ]),
            _: 1
          }, 8, ["modelValue", "disabled"])
        ]),
        _createElementVNode("div", _hoisted_11, [
          _createVNode(_component_el_select, {
            modelValue: _ctx.bodyParamsModel.jobIdList,
            "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.bodyParamsModel.jobIdList) = $event)),
            multiple: "",
            filterable: "",
            "collapse-tags": "",
            clearable: "",
            placeholder: "Selecione uma ou mais notificações",
            class: "w-100",
            disabled: !(Array.isArray(_ctx.availableJobsList))
          }, {
            default: _withCtx(() => [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.availableJobsList, (el) => {
                return (_openBlock(), _createBlock(_component_el_option, {
                  key: el.key,
                  value: el.key,
                  label: el.label
                }, null, 8, ["value", "label"]))
              }), 128))
            ]),
            _: 1
          }, 8, ["modelValue", "disabled"])
        ]),
        _createElementVNode("div", _hoisted_12, [
          _createVNode(_component_el_config_provider, {
            locale: _ctx.ptBr,
            style: {"width":"100%"}
          }, {
            default: _withCtx(() => [
              _createVNode(_component_el_date_picker, {
                id: "filter-main-form_remittance-date-range",
                type: "daterange",
                "range-separator": "-",
                "start-placeholder": "Início",
                "end-placeholder": "Fim",
                format: "DD/MM/YYYY",
                "value-format": "YYYY-MM-DD",
                modelValue: _ctx.bodyParamsModel.rangeDate,
                "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.bodyParamsModel.rangeDate) = $event)),
                style: {"width":"100%"}
              }, null, 8, ["modelValue"])
            ]),
            _: 1
          }, 8, ["locale"])
        ]),
        _createElementVNode("div", _hoisted_13, [
          _createVNode(_component_el_select, {
            modelValue: _ctx.bodyParamsModel.oldest,
            "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.bodyParamsModel.oldest) = $event)),
            filterable: "",
            "collapse-tags": "",
            placeholder: "Ordenação",
            clearable: "",
            class: "w-100"
          }, {
            default: _withCtx(() => [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.OLDEST_LIST, (el) => {
                return (_openBlock(), _createBlock(_component_el_option, {
                  key: el.key,
                  value: el.key,
                  label: el.label
                }, null, 8, ["value", "label"]))
              }), 128))
            ]),
            _: 1
          }, 8, ["modelValue"])
        ]),
        _createElementVNode("div", _hoisted_14, [
          _createVNode(_component_el_select, {
            modelValue: _ctx.bodyParamsModel.operationTypeList,
            "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((_ctx.bodyParamsModel.operationTypeList) = $event)),
            multiple: "",
            filterable: "",
            "collapse-tags": "",
            clearable: "",
            placeholder: "Selecione uma ou mais tipos",
            class: "w-100",
            disabled: !(Array.isArray(_ctx.OPERATION_TYPE_LIST))
          }, {
            default: _withCtx(() => [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.OPERATION_TYPE_LIST, (el) => {
                return (_openBlock(), _createBlock(_component_el_option, {
                  key: el.key,
                  value: el.key,
                  label: el.label
                }, null, 8, ["value", "label"]))
              }), 128))
            ]),
            _: 1
          }, 8, ["modelValue", "disabled"])
        ]),
        _createElementVNode("div", _hoisted_15, [
          _createVNode(_component_el_select, {
            modelValue: _ctx.bodyParamsModel.success,
            "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((_ctx.bodyParamsModel.success) = $event)),
            filterable: "",
            "collapse-tags": "",
            placeholder: "Status",
            clearable: "",
            class: "w-100"
          }, {
            default: _withCtx(() => [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.STATUS_LIST, (el) => {
                return (_openBlock(), _createBlock(_component_el_option, {
                  key: el.key,
                  value: el.key,
                  label: el.label
                }, null, 8, ["value", "label"]))
              }), 128))
            ]),
            _: 1
          }, 8, ["modelValue"])
        ]),
        _createElementVNode("div", _hoisted_16, [
          _createElementVNode("button", {
            onClick: _cache[9] || (_cache[9] = ($event: any) => (_ctx.handleGenerateExcelWithAllData())),
            class: "btn btn-sm w-100 h-100 background_btn_1_opct"
          }, _hoisted_19)
        ])
      ])
    ]),
    (!_ctx.isLoading)
      ? (_openBlock(), _createElementBlock("div", _hoisted_20, [
          (Array.isArray(_ctx.logListRender) && _ctx.logListRender.length > 0)
            ? (_openBlock(), _createElementBlock("div", _hoisted_21, [
                _createVNode(_component_CampTable, { class: "mb-0 mt-0" }, {
                  default: _withCtx(() => [
                    _createElementVNode("thead", null, [
                      _createElementVNode("tr", null, [
                        _createVNode(_component_CampTableTh, { class: "py-4" }, {
                          default: _withCtx(() => [
                            _createTextVNode("Título")
                          ]),
                          _: 1
                        }),
                        _createVNode(_component_CampTableTh, { class: "py-4" }, {
                          default: _withCtx(() => [
                            _createTextVNode("Mensagem")
                          ]),
                          _: 1
                        }),
                        _createVNode(_component_CampTableTh, { class: "py-4" }, {
                          default: _withCtx(() => [
                            _createTextVNode("Frequência")
                          ]),
                          _: 1
                        }),
                        _createVNode(_component_CampTableTh, { class: "py-4 text-center" }, {
                          default: _withCtx(() => [
                            _createTextVNode("Vendedor")
                          ]),
                          _: 1
                        }),
                        _createVNode(_component_CampTableTh, { class: "py-4 text-center" }, {
                          default: _withCtx(() => [
                            _createTextVNode("CPF")
                          ]),
                          _: 1
                        }),
                        _createVNode(_component_CampTableTh, {
                          class: "py-4 text-center",
                          style: {"white-space":"nowrap","min-width":"150px"}
                        }, {
                          default: _withCtx(() => [
                            _createTextVNode("Enviado por")
                          ]),
                          _: 1
                        }),
                        _createVNode(_component_CampTableTh, {
                          class: "py-4 text-center",
                          style: {"white-space":"nowrap","min-width":"250px"}
                        }, {
                          default: _withCtx(() => [
                            _createTextVNode("Enviado para")
                          ]),
                          _: 1
                        }),
                        _createVNode(_component_CampTableTh, { class: "py-4 text-center" }, {
                          default: _withCtx(() => [
                            _createTextVNode("Status")
                          ]),
                          _: 1
                        }),
                        _createVNode(_component_CampTableTh, { class: "py-4 text-center" }, {
                          default: _withCtx(() => [
                            _createTextVNode("Tipo")
                          ]),
                          _: 1
                        }),
                        _createVNode(_component_CampTableTh, { class: "py-4 text-center" }, {
                          default: _withCtx(() => [
                            _createTextVNode("Data")
                          ]),
                          _: 1
                        })
                      ])
                    ]),
                    _createElementVNode("tbody", null, [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.logListRender, (log) => {
                        return (_openBlock(), _createElementBlock("tr", {
                          key: log.id
                        }, [
                          _createVNode(_component_CampTableTd, { class: "py-4" }, {
                            default: _withCtx(() => [
                              _createTextVNode(_toDisplayString(log.title), 1)
                            ]),
                            _: 2
                          }, 1024),
                          _createVNode(_component_CampTableTd, { class: "py-4" }, {
                            default: _withCtx(() => [
                              _createTextVNode(_toDisplayString(log.message), 1)
                            ]),
                            _: 2
                          }, 1024),
                          _createVNode(_component_CampTableTd, { class: "py-4" }, {
                            default: _withCtx(() => [
                              _createTextVNode(_toDisplayString(log.frequency), 1)
                            ]),
                            _: 2
                          }, 1024),
                          _createVNode(_component_CampTableTd, { class: "py-4 text-center" }, {
                            default: _withCtx(() => [
                              _createTextVNode(_toDisplayString(log.competitorName), 1)
                            ]),
                            _: 2
                          }, 1024),
                          _createVNode(_component_CampTableTd, { class: "py-4 text-center" }, {
                            default: _withCtx(() => [
                              _createTextVNode(_toDisplayString(log.competitorCPF), 1)
                            ]),
                            _: 2
                          }, 1024),
                          _createVNode(_component_CampTableTd, { class: "py-4 text-center" }, {
                            default: _withCtx(() => [
                              _createTextVNode(_toDisplayString(log.user_name), 1)
                            ]),
                            _: 2
                          }, 1024),
                          _createVNode(_component_CampTableTd, { class: "py-4 text-center" }, {
                            default: _withCtx(() => [
                              _createTextVNode(_toDisplayString(log.send_to), 1)
                            ]),
                            _: 2
                          }, 1024),
                          _createVNode(_component_CampTableTd, { class: "py-4 text-center" }, {
                            default: _withCtx(() => [
                              _createTextVNode(_toDisplayString(log.status), 1)
                            ]),
                            _: 2
                          }, 1024),
                          _createVNode(_component_CampTableTd, { class: "py-4 text-center" }, {
                            default: _withCtx(() => [
                              _createTextVNode(_toDisplayString(log.type), 1)
                            ]),
                            _: 2
                          }, 1024),
                          _createVNode(_component_CampTableTd, { class: "py-4 text-center" }, {
                            default: _withCtx(() => [
                              _createTextVNode(_toDisplayString(log.created_at), 1)
                            ]),
                            _: 2
                          }, 1024)
                        ]))
                      }), 128))
                    ])
                  ]),
                  _: 1
                })
              ]))
            : (_openBlock(), _createBlock(_component_CampEmptyListFeedbackV2, {
                key: 1,
                id: "log-icon-empty-list-feedback"
              }, {
                icon: _withCtx(() => [
                  _hoisted_22
                ]),
                message: _withCtx(() => [
                  _createTextVNode(" Sem notificações registradas para este filtro! ")
                ]),
                _: 1
              })),
          _createVNode(_component_CampFooterPaginationControl, {
            class: "mt-5 mb-20",
            index: _ctx.indexCurrentPage,
            total: _ctx.totalPage,
            "onGet:UpdatedPageID": _cache[10] || (_cache[10] = (ID) => _ctx.handlePaginationRendering(ID))
          }, null, 8, ["index", "total"])
        ]))
      : _createCommentVNode("", true),
    (_ctx.isLoading)
      ? (_openBlock(), _createBlock(_component_el_skeleton, {
          key: 1,
          rows: 5
        }))
      : _createCommentVNode("", true)
  ]))
}